import Vehicle from './contexts/Vehicle.js';
import Dealer from './contexts/Dealer.js';
import Campaign from './contexts/Campaign.js';
import Content from './contexts/Content.js';
import Referrer from './contexts/Referrer.js';
import Software from './contexts/Software.js';
import OnlineSales2 from './contexts/OnlineSales2.js';
import ReturningUsers from './contexts/ReturningUsers.js';

export default class GlobalContextFinder {
  static get contexts() {
    return [
      Campaign,
      Content,
      Dealer,
      OnlineSales2,
      Referrer,
      ReturningUsers,
      Software,
      Vehicle,
    ];
  }

  static find(schema) {
    const result = this.contexts.filter(context => context.key === this._getKey(schema));
    if (result.length) {
      return result.shift();
    } else {
      throw Error('Cannot find the context');
    }
  }

  static _getKey(schema) {
    return schema.match(/iglu:uk.co.netdirector.snowplow\/(.*)\/jsonschema\/.*/)[1] || schema;
  }
}
